import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListExperiments from './submodules/list';
import EditExperiments from './submodules/edit';
import ListBuckets from './submodules/listBuckets';
import VersionHistory from './submodules/versionHistory';
import VersionList from './submodules/versionsList';
import ShowChanges from './submodules/showChanges';
import FixUsersBucket from './submodules/fixBucket';
import FindUserBucket from './submodules/findUserBucket';
import CreateExperiments from './submodules/create';

const ABTestDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].createExperiment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateExperiments}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperiments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListExperiments}
				exact
			/>

			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].updateExperiment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditExperiments}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperiments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/bucketDetails`}
				component={ListBuckets}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getVersionHistory]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/versionHistory`}
				component={VersionHistory}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getVersionHistory]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/showChanges`}
				component={ShowChanges}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperimentVersions]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/versionList`}
				component={VersionList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].fixUsersBucket]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/fixUsersBucket`}
				component={FixUsersBucket}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.abTest}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperiments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/findUserBucket`}
				component={FindUserBucket}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ABTestDashboard;
